/**
 * Shared media-frame geometry for feed cards.
 *
 * ReviewCard and RestaurantPostCard must render their media containers with
 * identical aspect ratio and desktop max-height so adjacent feed cards keep
 * matching heights. These classes live here (single source of truth) so the
 * two components cannot silently drift apart again.
 *
 * Contract test: `feedMediaFrame.test.ts` verifies both components consume
 * this constant and that no hardcoded copy of the geometry classes remains.
 */
/**
 * The feed's portrait aspect ratio on its own. Consumers that are not feed
 * cards but must keep their previews in the feed shape (e.g. the partner carousel
 * reorder screen's 4:5 thumbnail preview) use this piece without inheriting
 * the feed card's max-height/width constraints.
 */
export const FEED_MEDIA_ASPECT_CLASS = "aspect-[4/5]";

export const FEED_MEDIA_FRAME_CLASSES = `${FEED_MEDIA_ASPECT_CLASS} lg:max-h-[560px] w-full`;
